import React, { useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { PaykuService } from '../services/paykuService';

// Este componente no renderiza una interfaz visible, solo procesa webhooks
const PaykuWebhooks: React.FC = () => {
  useEffect(() => {
    // Esta función se ejecuta cuando se carga el componente
    const handleWebhook = async () => {
      try {
        console.log('Webhook de Payku recibido');
        
        // Obtener los parámetros de la URL
        const params = new URLSearchParams(window.location.search);
        const id = params.get('id');
        const token = params.get('token');
        const status = params.get('status');
        
        console.log('Parámetros recibidos:', {
          id,
          token,
          status
        });
        
        if (!id) {
          console.error('No se recibió ID de transacción');
          return;
        }
        
        // Verificar la transacción con Payku
        const paykuService = PaykuService.getInstance();
        const result = await paykuService.verifyTransaction(id);
        
        console.log('Resultado de verificación con Payku:', result);
        
        if (result.success) {
          console.log('Transacción verificada exitosamente');
          
          // La actualización del estado y la acreditación de monedas se maneja en verifyTransaction
        } else {
          console.error('Verificación de transacción fallida:', result.message);
        }
      } catch (error) {
        console.error('Error al procesar webhook de Payku:', error);
      }
    };
    
    // Ejecutar la función de manejo del webhook
    handleWebhook();
  }, []);
  
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg max-w-md w-full">
        <h1 className="text-2xl font-bold text-white mb-4">Procesando notificación de pago</h1>
        <p className="text-gray-300">
          Esta página procesa notificaciones de Payku. No es necesario que permanezcas en esta página.
        </p>
      </div>
    </div>
  );
};

export default PaykuWebhooks; 